import React from 'react';
import { Form as FoundryForm, FormProps } from '@bw/foundry';
import { useFormikContext } from 'formik';

/**
 * Form that automatically hooks into Formik's handleSubmit function
 */
const FormikForm = (props: FormProps) => {
  const { handleSubmit } = useFormikContext();
  return <FoundryForm onSubmit={handleSubmit} {...props} />;
};

export default FormikForm;
